<template>
  <fieldset>
    <ol class="questions compact">
      <li>
        <label
          :id="`${prefix}ResidenceLine1-label`"
          :for="`${prefix}ResidenceLine1`"
        >
          <span class="label">Address line 1</span>
        </label>

        <input
          autocomplete="off"
          class="autoCompleteAddress stretchWidth"
          :id="`${prefix}ResidenceLine1`"
          type="text"
          size="40"
          :name="`${prefix}ResidenceLine1`"
          maxlength="255"
          role="presentation"
          v-model="addressDetails.residenceLine1"
          ref="streetRef" 
        />
      </li>
      <li class="group">
        <ol class="questions compact">
          <li>
            <label
              :id="`${prefix}ResidenceSuburb-label`"
              :for="`${prefix}ResidenceSuburb`"
            >
              <span class="label">City, town or suburb</span>
            </label>
            <input
              autocomplete="off"
              :id="`${prefix}ResidenceSuburb`"
              type="text"
              size="15"
              :name="`${prefix}ResidenceSuburb`"
              maxlength="255"
              role="presentation"
              v-model="addressDetails.residenceSuburb"
            />
          </li>
          <li>
            <label
              :id="`${prefix}ResidenceState-label`"
              :for="`${prefix}ResidenceState`"
            >
              <span class="label">State or territory</span>
              <small class="hint"></small>
            </label>

            <input
              autocomplete="off"
              :id="`${prefix}ResidenceState`"
              type="text"
              size="5"
              :name="`${prefix}ResidenceState`"
              maxlength="255"
              role="presentation"
              v-model="addressDetails.residenceState"
            />
          </li>

          <li>
            <label
              :id="`${prefix}ResidencePostcode-label`"
              :for="`${prefix}ResidencePostcode`"
            >
              <span class="label">Postcode</span>
            </label>

            <input
              autocomplete="off"
              :id="`${prefix}ResidencePostcode`"
              type="text"
              size="5"
              :name="`${prefix}ResidencePostcode`"
              maxlength="10"
              role="presentation"
              v-model="addressDetails.residencePostcode"
            />
          </li>
          <li v-if="residentialAddressAustralia === 'false'">
            <label
              :id="`${prefix}ResidenceCountry-label`"
              :for="`${prefix}ResidenceCountry`"
            >
              <span class="label">Country</span>
            </label>

            <input
              autocomplete="off"
              :id="`${prefix}ResidenceCountry`"
              type="text"
              size="30"
              :name="`${prefix}ResidenceCountry`"
              maxlength="255"
              role="presentation"
              v-model="addressDetails.residenceCountry"
            />
          </li>
        </ol>
      </li>
    </ol>
  </fieldset>
</template>

<script>
const google = window.google;

export default {
  mounted() {
    if (window.location.href.indexOf('http://localhost') == 0) {
			console.debug('google places disabled for local dev since it does not work');
			return;
		}
    
    let autoComplete = new google.maps.places.Autocomplete(this.$refs.streetRef, {
      types: ['address'],
      fields: ['address_component'],
      componentRestrictions: { country: 'au' },
      bounds: new google.maps.LatLngBounds(new google.maps.LatLng(-27.917574, 153.702789))
    });

    google.maps.event.addListener(autoComplete, "place_changed", () => {

      const mapping = {
        street_number: 'streetNumber',
        route: 'street',
        locality: 'city',
        postal_code: 'postcode',
        administrative_area_level_1: 'state'
      };

      for (const type in mapping) {
        this.addressDetails[mapping[type]] = '';
      }

      let place = {
        address_components: [],
        ...autoComplete.getPlace()
      }

      place.address_components.forEach((component) => {
        component.types.forEach((type) => {
          if (Object.prototype.hasOwnProperty.call(mapping, type)) {
            this.address[mapping[type]] = component.long_name;
          }
        })
      });
      this.address.street = this.residenceLine1;

      this.addressDetails.residenceLine1 = this.address.street;
      this.addressDetails.residencePostcode = this.address.postcode;
      this.addressDetails.residenceState = this.address.state;
      this.addressDetails.residenceSuburb = this.address.city;
    })
  },

  data() {
    return {
      address: {
        street: '',
        streetNumber: '',
        city: '',
        state: '',
        country: '',
      }
    }
  },
  computed: {
    residenceLine1() {
      return this.address.streetNumber + ' ' + this.address.street;
    }, 
    addressDetails: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  props: {
    prefix: String,
    residentialAddressAustralia: {
      type: String, 
      default: "true"
    },
    value: Object
  },
}
</script>